module.exports = __webpack_public_path__ + "img/successful.4e83807e.png";